import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {MenuCompositionDTO} from '../../core/dtos/menucomposition-dto';
import {PreferencesUtilisateurService} from '../../core/services/preferences-utilisateur.service';
import {UtilsService} from '../../core/utils/utils.service';
import {USER_PREFERENCE} from '../../core/constants';
import {Subscription} from 'rxjs';

@Component({
    selector: 'yo-marge',
    templateUrl: './marge.component.html',
    styleUrls: ['./marge.component.scss'],
    standalone: false
})
export class MargeComponent implements OnInit {

  @Input() menuCompo: MenuCompositionDTO;
  subDisplay: Subscription;
  displayCoutsDetails: boolean = false;

  constructor(private cd: ChangeDetectorRef,
              private prefsUserSvc: PreferencesUtilisateurService,
              private utils: UtilsService) {
  }

  ngOnInit() {
    this.subcriptionDisplayCoutsDetails();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subDisplay);
  }

  subcriptionDisplayCoutsDetails = () => {
    this.subDisplay = this.prefsUserSvc.preferencesOfUser$.subscribe(item => {
      this.displayCoutsDetails = this.prefsUserSvc.getPreferenceUtilisateurBooleanValue(USER_PREFERENCE.GESTIONMENUS_DISPLAY_ANALYSE_FINANCIERE);
      this.cd.markForCheck();
    });
  };
}
